import useFetchIam from '../../api/useFetchIam';
import OrganizationEditPage from '../pages/EditPage';
import EditStaffPage from '../pages/StaffForm';

export default function OrganizationSettingsTemplate() {
  const { data: iam } = useFetchIam();

  if (!iam?.current_user) return null;

  return iam.current_user.is_admin ? <OrganizationEditPage /> : <EditStaffPage />;
}
